import { useEffect } from 'react';
import { Modal, Text, useMantineTheme } from '@mantine/core';

type ErrorNotificationProps = {
  opened: boolean;
  onClose(): void;
  message: string;
  /** milliseconds before auto-close (default: 5000ms) */
  autoCloseDelay?: number;
};

export default function ErrorNotification({
  opened,
  onClose,
  message,
  autoCloseDelay: autoCloseMs = 5000,
}: ErrorNotificationProps) {
  const theme = useMantineTheme();

  // Auto‐close timer
  useEffect(() => {
    if (!opened) return;
    const timer = setTimeout(onClose, autoCloseMs);
    return () => clearTimeout(timer);
  }, [opened, autoCloseMs, onClose]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton
      closeOnClickOutside
      size="sm"
      title={<Text fw={700} c="white">Error</Text>}
    overlayProps={{ color: 'transparent', opacity: 0 }}
      styles={{
        // Header wrapper
        header: {
          backgroundColor: theme.colors.red[7],
          borderBottom: 'none',
          padding: theme.spacing.md,
        },
        // Modal content (body) wrapper
        content: {
          backgroundColor: theme.colors.red[7],
          color: theme.white,
          padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
        },
        // Title text (you already colored it white above, but you could tweak here)
        title: {
          marginBottom: 0,
        },
        // Close button
        close: {
          color: theme.white,
        },
      }}
    >
      <Text size="sm">{message}</Text>
    </Modal>
  );
}
